module.exports = __webpack_public_path__ + "static/media/bg1.84ba3e2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/bg1.mp3
// module id = ik+N
// module chunks = 1